export class RequestInterceptor {
  static register (interceptor) {
    this.interceptor = interceptor
  }

  static get () {
    return this.interceptor
  }

  static reset () {
    this.interceptor = undefined
  }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@rails/request.js/src/request_interceptor.js
// module id = 1019
// module chunks = 3 6 8